const state = {
  visible     : true,
  boardStream : ''
}
const getters = {
  visible     : state => state.visible,
  boardStream : state => state.boardStream
}
const mutations = {
  setBoardStream (state, stream) {
    state.boardStream = stream
  }
}
const actions   = {}

export default {
  namespaced: true,
  state,
  getters,
  mutations,
  actions
}



// WEBPACK FOOTER //
// ./src/components/video/store/stream.js